<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <!-- {{$store.getters.ruangKosong}} -->
          <v-card-title>
            <h3><b>Tambah Peminjaman</b></h3>
          </v-card-title>
          <v-divider></v-divider>
          <v-snackbar
            v-model="show"
            multi-line="true"
            top="true"
            color="green"
          >
            {{ notifMsg }}
            <v-btn
              color="pink"
              flat
              @click="show = false"
            >
              Tutup
            </v-btn>
          </v-snackbar>
          <v-snackbar
            v-model="show2"
            multi-line="true"
            top="true"
            color="red"
          >
            {{ notifMsg }}
            <v-btn
              color="pink"
              flat
              @click="show2 = false"
            >
              Tutup
            </v-btn>
          </v-snackbar>
          <v-card-text>
            <v-form @submit.prevent="onSubmit" class="px-3">
              <div class="red--text lighten-1--text" v-if="$v.form.namaPIC.$error" style="font-size: x-small"><i>Nama PIC Harus Diisi</i></div>
              <v-text-field
                label="Nama PIC"
                v-model="form.namaPIC"
                :class="{'is-invalid': $v.form.namaPIC.$error}"
                :rules="form.namaPICRules">
              </v-text-field>
              <div class="red--text lighten-1--text" v-if="$v.form.idJenisPenggunaanRuangan.$error" style="font-size: x-small"><i>Jenis Penggunaan Ruangan Harus Dipilih</i></div>
              <v-select
                name="jenis_peminjaman"
                label="Jenis Peminjaman"
                :items="peminjaman"
                :class="{'is-invalid': $v.form.idJenisPenggunaanRuangan.$error}"
                v-model="form.idJenisPenggunaanRuangan">
              </v-select>
              <div class="red--text lighten-1--text" v-if="$v.idLokasi.$error" style="font-size: x-small"><i>Lokasi Harus Dipilih</i></div>
              <v-select
                name="lokasi"
                label="Lokasi"
                :items="lokasi"
                v-model="idLokasi"
                :class="{'is-invalid': $v.idLokasi.$error}"
                @change="onLokasi"
               >
              </v-select>
              <div class="red--text lighten-1--text" v-if="$v.idGedung.$error" style="font-size: x-small"><i>Gedung Harus Dipilih</i></div>
              <v-select
                name="nama_gedung"
                label="Gedung"
                :items="gedung"
                @change="onGedung"
                v-model="idGedung"
                :class="{'is-invalid': $v.idGedung.$error}"
              >
              </v-select>
              <div class="red--text lighten-1--text" v-if="$v.form.idRuangan.$error" style="font-size: x-small"><i>Ruangan Harus Dipilih</i></div>
              <v-select name="ruangan"
                        label="Ruangan"
                        :items="ruangan"
                        v-model="form.idRuangan"
                        :onChange="onMaxRuangan(form.idRuangan)">
              </v-select>
              Maximum Kapasitas Ruangan: {{maxRuangan}}
              <v-layout row wrap>
                <v-flex xs11 sm5>
                  <v-menu
                    ref="menu"
                    v-model="menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="date"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="date1"
                        label="Tanggal Mulai"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date1" no-title scrollable :min="minDate">
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        style="min-width:100px;"
                        @click="menu1= false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        style="min-width:100px;"
                        @click="$refs.menu.save(date);menu1=false"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                  <v-menu
                    ref="menu"
                    v-model="menu2"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="date2"
                        label="Tanggal Selesai"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date2" no-title scrollable :min="minDate">
                      <div class="flex-grow-1"></div>
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        style="min-width:100px;"
                        @click="menu2 = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        style="min-width:100px;"
                        @click="$refs.menu.save(date);menu2=false"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs11 sm5>
                  <v-menu
                    ref="menu"
                    v-model="menu3"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="time"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="time1"
                        label="Waktu Mulai"
                        prepend-icon="access_time"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker v-if="menu3" format="24hr" v-model="time1" :min="minTime" full-width>
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        style="min-width:100px;"
                        @click="menu3= false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        style="min-width:100px;"
                        @click="onOkHour(date)"
                      >
                        OK
                      </v-btn>
                    </v-time-picker>
                  </v-menu>
                  <v-menu
                    ref="menu"
                    v-model="menu4"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="time"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="time2"
                        label="Waktu Selesai"
                        prepend-icon="access_time"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker v-if="menu4" format="24hr" v-model="time2" :min="minTime" full-width >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        style="min-width:100px;"
                        @click="menu4= false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        style="min-width:100px;"
                        @click="$refs.menu.save(date);menu4=false"
                      >
                        OK
                      </v-btn>
                    </v-time-picker>
                  </v-menu>
                </v-flex>
              </v-layout>

              <!-- File Upload -->
              <div v-if="form.idJenisPenggunaanRuangan!=1">
              <input
                type="file"
                style="display: none"
                ref="fileInput"
                @change="onFileSelected"
              >
              <v-btn v-if="true" raised color="orange" @click="onPickFile">
                <v-icon dark left>cloud_upload</v-icon> Upload File
              </v-btn>
              <label>{{filename}}</label>
              <p><em><font color="red">Tipe format file yang di upload adalah <b>pdf</b> dan maksimal berukuran 200Mb</font></em></p>
              </div>
              <!----------------->

              <v-spacer></v-spacer>

              <v-textarea label="Deskripsi" v-model="form.deskripsi"></v-textarea>
              <v-card-actions class="justify-center">
                <v-btn
                  type="submit"
                  class="btn-simpan"
                  color="blue"
                  dark
                  style="width:120px;"
                >
                  <v-icon left>
                    fa fa-check
                  </v-icon>
                  Simpan
                </v-btn>
                <v-btn
                  class="btn-batal"
                  color="red"
                  dark
                  @click="onBatal"
                  style="width:120px;"
                >
                  <v-icon left>
                    fa fa-times
                  </v-icon>
                  Batal
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
    import {base} from "../../setup-axios"
    import {createJWT} from "../../store/module/helper";
    import { mapGetters,  mapActions} from 'vuex'
    import {required} from "vuelidate/lib/validators"
    import {isNotNull} from "../../validation";
    import moment from "moment"

    const regexNamaPIC = new RegExp(/^[a-zA-Z ]*$/)

    export default {
        name: "Add",
        data() {
            return {
                multiple: [
                    {
                        text: "Ya",
                        value: 1
                    },
                    {
                        text: "Tidak",
                        value: 2
                    }
                ],
                maxRuangan: "",
                peminjaman: [],
                lokasi: [],
                ruangan: [],
                gedung: [],
                idLokasi: null,
                idGedung: null,
                show: false,
                show2: false,
                menu1: false,
                menu2: false,
                menu3: false,
                menu4: false,
                date1: "",
                date2: "",
                time1: null,
                time2: null,
                filename: "No File Choosen",
                fileUpload: null,
                fileType:"",
                form: {
                    mulai: null,
                    selesai: null,
                    timestampDiajukan: null,
                    timestampApproval: null,
                    deskripsi: "",
                    kodeJadwalRutin: null,
                    usernamePengaju: localStorage.getItem("user"),
                    namaPIC: "",
                    namaPICRules: [
                        v => !!v || 'Nama PIC tidak boleh kosong',
                        v => regexNamaPIC.test(v) || 'Nama PIC Hanya Boleh Terdiri Dari Huruf',
                    ],
                    usernamePemberiKeputusan: "hening",
                    idRuangan: null,
                    idStatusPenggunaanRuangan: 1,
                    idJenisPenggunaanRuangan: null,
                    kapasitas: null,
                    urlFile: ""
                }
            }
        },
        validations: {
          idLokasi: {
            isNotNull
          },
          idGedung: {
            isNotNull
          },
          form : {
            namaPIC: {
              required
            },
            idJenisPenggunaanRuangan: {
              isNotNull
            },
            idRuangan: {
              isNotNull
            }
          }
        },
        created(){
            // console.log(this.$store.getters)
            base.get("penggunaanRuangan/" + this.$route.params.id,
             {
               headers: {
                 Authorization: createJWT()
               }
             }
            ).then((resp) => {
                console.log(resp.data)
                if(resp.data.result.length == 0){
                    this.form2 = resp.data.result[0]
                    console.log(this.form2)
                }

                else {
                    this.form2 = resp.data.result[0]
                    console.log(this.form2)
                }
            })

            base.get("jenisPenggunaanRuangan",
             {
               headers: {
                 Authorization: createJWT()
               }
             }
            ).then((resp) => {
                for(var i=0; i < resp.data.result.length;i++){
                    if(localStorage.getItem("role") == "mhs"){
                        if(resp.data.result[i].nama === "Insidental"){
                            this.peminjaman = ({value:resp.data.result[i].id,text:resp.data.result[i].nama})
                        }
                    }
                    if(localStorage.getItem("role") == "dos"){
                        if(resp.data.result[i].nama !== "Kuliah Rutin"){
                            this.peminjaman.push({value:resp.data.result[i].id,text:resp.data.result[i].nama})
                        }
                    }

                    else {
                        this.peminjaman.push({value:resp.data.result[i].id,text:resp.data.result[i].nama})
                    }
                }
            })

          base.get("lokasi/dropdown",
             {
               headers: {
                 'Authorization' : createJWT()
               }
             }
            ).then((resp) => {
            for(var i=0; i < resp.data.result.length;i++){
              this.lokasi.push({value:resp.data.result[i].id,text:resp.data.result[i].nama})
            }
          })

            //redirect lokasi from ruangKosong
            this.idLokasi = this.$store.getters.ruangKosong.idLokasi === null ? null : this.$store.getters.ruangKosong.idLokasi

            //redirect gedung from ruangKosong
            if (this.$store.getters.ruangKosong.id != null) {
              base.get("gedung/lokasi/" + this.idLokasi ,
                 {
                   headers: {
                     'Authorization' : createJWT()
                   }
                 }
              ).then((resp) => {
                this.gedung = []
                for(var i=0; i < resp.data.result.length;i++){
                  this.gedung.push({value:resp.data.result[i].id,text:resp.data.result[i].nama})
                }
              })
                .catch(function(error) {
                  console.log('ERROR : ', error)
                  console.log('isi dari error', error.response)
                })

              this.idGedung = this.$store.getters.ruangKosong.idGedung === null ? null : this.$store.getters.ruangKosong.idGedung

              //redirect ruang from ruangan kosong
                base.get("ruangan/dropdown/byGedung/" + this.idGedung,
                 {
                   headers: {
                     Authorization: createJWT()
                   }
                 }
                ).then((resp) => {
                    for(var i=0; i < resp.data.result.length;i++){
                        this.ruangan.push({value:resp.data.result[i].id,text:resp.data.result[i].nama})
                    }
                })
                    .catch(function(error) {
                        console.log('ERROR : ', error)
                        console.log('isi dari error', error.response)
                    })

                this.form.idRuangan = this.$store.getters.ruangKosong.id === null ? null : this.$store.getters.ruangKosong.id
            }

            //redirect waktu from ruangKosong
            var waktu = this.$store.getters.ruangKosong.jamKosong === null ? null : this.$store.getters.ruangKosong.jamKosong
            if (waktu != null) {
                var tempWaktu = waktu.split(" ")
                this.date1 = tempWaktu[0]
                this.time1 = tempWaktu[1]
                this.date2 = tempWaktu[3]
                this.time2 = tempWaktu[4]
            }

        },
        computed:{
            ...mapGetters(["ruangKosong"]),
            ...mapGetters(["snackbar"]),
            computedDateFormatted() {
                return this.formatDate(this.date)
            },
            minDate(){
                const today = new Date();
                // const dd = today.getUTCDate();
                return this.setMinDate(today);
            },
            minTime(){
                const today = new Date()
                return this.setMinTime(today);
            }
        },
        methods: {
            ...mapActions(["fetchSnackbar", "fetchMsgSnackbar", "fetchPathSnackbar"]),
            onMaxRuangan(id){
                base.get("/ruangan/"+id,
               {
                 headers: {
                   Authorization: createJWT()
                 }
               }
           ).then(resp => {
                    this.maxRuangan = resp.data.resultById.kapasitasMaksimal
                })
            },
            setMinDate(date) {
                let month = `${date.getMonth() + 1}`;
                let day = `${date.getDate()}`;
                const year = date.getFullYear();

                if (month.length < 2) month = `0${month}`;
                if (day.length < 2) day = `0${day}`;

                return [year, month, day].join('-');
            },
            setMinTime(date){
              var pickedDate = Date.parse(this.date1.replace(/-/g, " "));

              if(pickedDate > date){
                return "00:00"
              }

              else {
                return date.getHours() + ":" + date.getMinutes()
              }
            },
            onPickFile() {
                this.$refs.fileInput.click()
            },
            onFileSelected(event) {
                // console.log(event)
                this.filename = event.target.files[0].name
                this.fileUpload = event.target.files[0]
                this.fileType = event.target.files[0].type
            },
            onBatal() {
                this.$router.push("/daftar-ruangan-tersedia/daftar-ruangan-tersedia")
            },
            formatDate(date) {
                if (!date) return null

                const [year, month, day] = date.split("-")
                return `${day}-${month}-${year}`
            },
            onSubmit(){
                this.$v.$touch();
                if(this.$v.$error) return

                var url = "/penggunaanRuangan"

                this.form.timestampDiajukan = null
                this.form.timestampApproval = null
                this.form.mulai = this.formatDate(this.date1) + " " + this.time1
                this.form.selesai = this.formatDate(this.date2) + " " + this.time2

                let validateTime = this.onValidateTime(this.date1+" "+this.time1, this.date2 + " " + this.time2)

                let thisVM = this

                if(validateTime){
                    const formData = new FormData();
                    formData.append("file", this.fileUpload);

                    // if(this.validateEmptyFile()){

                        // if(this.validateFileType()){

                            base
                                .post(url + "/upload", formData,
                                {
                                  headers: {
                                    Authorization: createJWT()
                                  }
                                })
                                .then(resp => {
                                    this.form.urlFile = resp.data.object
                                    base.post( url, this.form,
                                     {
                                       headers: {
                                         Authorization: createJWT()
                                       }
                                     })
                                        .then((resp) => {
                                            console.log('Success');
                                            console.log(resp.data);
                                            if(resp.data.status == 200){
                                                thisVM.show2 = true
                                                thisVM.notifMsg = resp.data.message
                                            }

                                            else {
                                                thisVM.fetchSnackbar(true, 'Berhasil Menambah data', 'peminjaman')
                                                thisVM.fetchMsgSnackbar("Berhasil Menambah Data")
                                                thisVM.fetchPathSnackbar("peminjaman")
                                                thisVM.$router.push('/peminjaman/peminjaman')
                                            }
                                        }).catch(function(error) {
                                        console.log('ERROR : ', error)
                                        console.log('isi dari error', error.response)
                                        thisVM.show2 = true
                                        thisVM.notifMsg = 'Gagal Memasukan data'
                                    })

                                })
                                .catch(error => {
                                    console.log("There was an error:", error);
                                });
                        // }
                    // }


                } else{
                    this.show2 = true
                    this.notifMsg = 'Terjadi Kesalahan Pada Input Waktu Atau Tanggal'
                }

            },

            validateEmptyFile() {
                var isValid = true;
                console.log("DEBUG : ")
                console.log(this.fileUpload)
                console.log(this.fileUpload === null)
                if(this.fileUpload === null){
                    this.show2 = true
                    this.notifMsg = 'File Belum di Upload'
                    isValid = false
                }
                return isValid
            },
            validateFileType() {
                var isValid = true;
                if(this.fileType != "application/pdf"){
                    this.show2 = true
                    this.notifMsg = 'Type File yg Diijinkan Adalah PDF'
                    isValid = false
                }
                return isValid
            },
          onLokasi(){
            base.get("gedung/lokasi/" + this.idLokasi ,
               {
                 headers: {
                   'Authorization' : createJWT()
                 }
               }
              ).then((resp) => {
              this.gedung = []
              for(var i=0; i < resp.data.result.length;i++){
                this.gedung.push({value:resp.data.result[i].id,text:resp.data.result[i].nama})
              }
            })
              .catch(function(error) {
                console.log('ERROR : ', error)
                console.log('isi dari error', error.response)
              })
          },
            onGedung() {
                console.log(this.idGedung)
                base.get("ruangan/dropdown/byGedung/" + this.idGedung,
                 {
                   headers: {
                     Authorization: createJWT()
                   }
                 }
                ).then((resp) => {
                  this.ruangan = []
                  for(var i=0; i < resp.data.result.length;i++){
                      console.log(resp.data)
                      this.ruangan.push({value:resp.data.result[i].id,text:resp.data.result[i].nama})
                  }
                })
                    .catch(function(error) {
                        console.log('ERROR : ', error)
                        console.log('isi dari error', error.response)
                    })
            },
            onValidateTime(mulai, selesai){
                var dateMulai = new Date(mulai)
                var dateSelesai = new Date(selesai)
                console.log("debug " + mulai)
                console.log("debug" + selesai)
                console.log(mulai < selesai)
                return (mulai < selesai)

            },

          onOkHour(date){
            var dateNow = new Date(moment(Date.now()).format('YYYY-MM-DD HH:mm:ss'))
            var dateMulai = new Date(this.date1 + " " + this.time1 + ":00")
            var dateDiff = Math.abs(dateMulai - dateNow) / (60 * 60 * 1000)
            console.log(Math.floor(dateDiff))

            if(localStorage.getItem("role") == "admin" || localStorage.getItem("role") == "RT"
              || localStorage.getItem("role") == "ruang"){

              this.$refs.menu.save(date)
              this.menu3 = false
            }

            else {
              if(Math.floor(dateDiff) >= 3){
                this.$refs.menu.save(date)
                this.menu3 = false
              }

              else {
                this.show2 = true
                this.notifMsg = 'Peminjaman yang diajukan tidak boleh kurang dari 3 Jam, terhitung dari jam saat ini'
              }
            }

          }
        },
        watch: {
            date(val) {
                this.dateFormatted = this.formatDate(this.date)
            }
        }
    }
</script>

<style scoped>
</style>